import { defineTitleId } from '../anchors';

import type { ISbStoryData } from 'storyblok-js-client';

import type { ReviewCardProps } from '@monoimin/sb-types';

export function createPropsForReviewCards(
  stories: ISbStoryData[],
  customers: ISbStoryData[]
) {
  return stories.reduce<ReviewCardProps[]>((acc, item) => {
    const customer = customers.find((el) => el.uuid === item.content.customer);

    const param = customer?.content?.name || item.slug;

    const searchParam = defineTitleId(param, 'en');

    return [
      ...acc,
      {
        reviewText: item.content.text,
        customer: customer
          ? {
              country: customer.content.country as string,
              description: customer.content.description,
              name: customer.content.name,
              image: customer.content.image?.filename,
            }
          : null,
        slug: item.slug ?? '',
        heading: item.content.heading,
        withBackground: !!item.content.withBackground,
        searchParam: searchParam,
      },
    ];
  }, []);
}

export default createPropsForReviewCards;
